<template>
  <div class="main">
    <h6 class="flex-wrp">
      <span class="category-tag btn" v-on:click="change(76)"
        :class="searchOpt.category == 76 ? 'tagon' : 'tagoff'">前菜＆サラダ</span>
      <span class="category-tag btn" v-on:click="change(77)"
        :class="searchOpt.category == 77 ? 'tagon' : 'tagoff'">フリット</span>
      <span class="category-tag btn" v-on:click="change(78)"
        :class="searchOpt.category == 78 ? 'tagon' : 'tagoff'">メイン料理</span>
      <span class="category-tag btn" v-on:click="change(73)" :class="searchOpt.category == 73 ? 'tagon' : 'tagoff'">Rosso
        トマトソース</span>
      <span class="category-tag btn" v-on:click="change(74)" :class="searchOpt.category == 74 ? 'tagon' : 'tagoff'">Bianco
        オイルベース</span>
      <span class="category-tag btn" v-on:click="change(75)" :class="searchOpt.category == 75 ? 'tagon' : 'tagoff'">Crema
        クリームベース</span>
      <span class="category-tag btn" v-on:click="change(79)"
        :class="searchOpt.category == 79 ? 'tagon' : 'tagoff'">パスタ＆リゾット</span>
      <span class="category-tag btn" v-on:click="change(80)"
        :class="searchOpt.category == 80 ? 'tagon' : 'tagoff'">ワインのおともに</span>
      <span class="category-tag btn" v-on:click="change(81)"
        :class="searchOpt.category == 81 ? 'tagon' : 'tagoff'">デザート</span>
    </h6>
    <div id="listview">
      <div v-for="item in items" :key="item[0]" class="card">
        <div class="card-body">
          <h5 class="card-title">{{ item[1] }}</h5>
          <h6 class="card-subtitle mb-2 text-muted">{{ item[4] }}</h6>
          <p class="card-text">{{ item[6] }}</p>
        </div>
        <img v-if="item[13]" v-bind:src="item[13]" class="card-img-top" alt="...">
      </div>
    </div>
  </div>
</template>
<script>
import sx from '../utils/core.js'
// Import jquery
import $ from 'jquery'
// Make it available globally as it needs to be accessible within the single file components (.vue)
window.$ = $

export default {
  created() {
    this.$store.state.title = 'メニュー情報'
    this.$store.state.pageBack = 'Menu'
  },
  data() {
    return {
      items: [],
      searchOpt: {
        category: '76',
        kbn: '60'
      }
    }
  },
  mounted() {
    $('#navbarSupportedContent').collapse({
      toggle: false
    }).collapse('hide')
    sx.showWaiting()
    const that = this

    var params = {
      bucketid: '17',
      options: JSON.stringify(that.searchOpt),
      token: localStorage.getItem('token')
    }
    var url = that.$store.state.baseurl + '/app/cmshelper/fetchPostList'
    sx.request(
      url,
      params,
      function (result) {
        if (result.status === 'ok') {
          that.items = [];
          $.each(result.data.rows, function (index, row) {
            var metadata = JSON.parse(row[10] || '{}')
            if (metadata.gallery && metadata.gallery.length > 0 && !sx.isNothingOrEmpty(metadata.gallery[0])) {
              row.push(that.$store.state.baseurl + metadata.gallery[0])
            }
            that.items.push(row)
          });
          sx.hideWaiting()
        } else {
          sx.toastSuccess(result.message)
          console.log(result.message)
        }
      },
      function () {
        sx.login(
          url,
          params,
          function (result) {
            if (result.status === 'ok') {
              that.items = result.data.rows
              sx.hideWaiting()
            } else {
              sx.toastSuccess(result.message)
              console.log(result.message)
            }
          }
        )
      }
    )
  },
  methods: {
    change(cateid) {
      sx.showWaiting()
      const that = this

      that.searchOpt.category = cateid;
      var params = {
        bucketid: '17',
        options: JSON.stringify(that.searchOpt),
        token: localStorage.getItem('token')
      }
      var url = that.$store.state.baseurl + '/app/cmshelper/fetchPostList'
      sx.request(
        url,
        params,
        function (result) {
          if (result.status === 'ok') {
            that.items = [];
            $.each(result.data.rows, function (index, row) {
              var metadata = JSON.parse(row[10] || '{}')
              if (metadata.gallery && metadata.gallery.length > 0 && !sx.isNothingOrEmpty(metadata.gallery[0])) {
                row.push(that.$store.state.baseurl + metadata.gallery[0])
              }
              that.items.push(row)
            });
            sx.hideWaiting()
          } else {
            sx.toastSuccess(result.message)
            console.log(result.message)
          }
        },
        function () {
          sx.login(
            url,
            params,
            function (result) {
              if (result.status === 'ok') {
                that.items = result.data.rows
                sx.hideWaiting()
              } else {
                sx.toastSuccess(result.message)
                console.log(result.message)
              }
            }
          )
        }
      )
    }
  }
}
</script>
<style scoped>
.flex-wrp {
  display: flex;
  flex-wrap: wrap;
  position: fixed;
  top: 60px;
}

.category-tag {
  height: 34rpx;
  line-height: 34rpx;
  font-size: 8pt;
  text-align: center;
  justify-content: center;
  margin-bottom: 10rpx;
  border-radius: 4px;
  padding: 0 10rpx;
  margin-right: 10rpx;
  background: #FFCC66;
  color: # 8fb7d5;
  margin: 2px;
  padding: 6px;
}

#listview {
  margin: 100px 4px 4px 0;
  overflow-y: auto;
  height: 100vh;
  overflow: scroll;
}

#listview .card {
  text-align: left;
  margin-top: 6px;
}

.card-subtitle {
  color: #fb6e14;
}

small {
  color: #fb6e14;
}

.lead {
  padding-top: 20px;
  text-align: left;
  color: #fb6e14;
}

.main {
  padding: 4px;
}

.tagon {
  background: #FF9900;
}

#app {
  overflow-y: none;
}
</style>
